import React,{useState} from "react";
import style from "./ReceivingAndPaymentReference.module.css"
import InputField from "../../components/StockScreenReference/InputField";
import { useForm } from "react-hook-form";
import SelectFiled from "../../components/StockScreenReference/SelectField";
import TableInput from "../../components/StockScreenReference/TableInput";

const ReceivingAndPaymentReference = () => {
    const {register, handleSubmit, setValue} = useForm();
    const [showTable, setShowTable] = useState(false);
    const INPUTS1 = [
        {
            name: 'data',
            element: 'input',
            type: 'text',
            label: '年月日',
            styles: {

            },
        },
        {
            name: 'consignor',
            element: 'input',
            type: 'text',
            label: '荷主',
            styles: {

            },
        },
        {
            name: 'warehouse1',
            element: 'select',
            option: ['倉庫A','倉庫B','倉庫C'], // ダミー
            label: '倉庫',
            styles: {

            },
        },
        {
            name: 'warehouse2',
            element: 'select',
            option: ['倉庫A','倉庫B','倉庫C'], // ダミー
            label: '',
            styles: {

            },
        },
    ]
    const INPUTS2 = [
        {
            name: 'item1',
            element: 'input',
            type: 'text',
            label: '商品No',
            styles: {

            },
        },
        {
            name: 'item2',
            element: 'input',
            type: 'text',
            label: '',
            styles: {

            },
        },
    ]
    const INPUTS3 = [
        {
            name: 'partNoClassification',
            element: 'select',
            option: ['A','B','C'], // ダミー
            label: '品番区分',
            styles: {
                marginRight: '34px',
            },
        },
        {
            name: 'lotNo',
            element: 'input',
            type: 'text',
            label: 'ロットNo',
            styles: {
                width:'260px'
            },
        },
    ]

    const TABELS = [
        {
            name:'data',
            label:'年月日',
            styles: {
                width:''
            },
        },
        {
            name:'inputClassification',
            label:'入力区分',
            styles: {
                width: '',
            },
        },
        {
            name:'slipNo',
            label:'伝票No',
            styles: {
                width: '',
            },
        },
        {
            name:'processingClassification',
            label:'処理区分',
            styles: {
                width: '',
            },
        },
        {
            name:'warehouse',
            label:'倉庫',
            styles: {
                width: '',
            },
        },
        {
            name:'location',
            label:'ロケーション',
            styles: {
                width: '',
            },
        },
        {
            name:'lotNo',
            label:'ロットNo',
            styles: {
                width: '',
            },
        },
        {
            name:'warehousing',
            label:'入庫',
            styles: {
                width: '',
            },
        },
        {
            name:'shipping',
            label:'出庫',
            styles: {
                width: '',
            },
        },
        {
            name:'stock',
            label:'在庫',
            styles: {
                width: '',
            },
        },
        {
            name:'billingCategory',
            label:'請求区分',
            styles: {
                width: '',
            },
        },
    ]
    const TABLE_COUNT = [1,2,3,4,5,6];

        
    const onSubmit = data => {
        setShowTable(true);
        // ダミー
        setValue('tables', {
            data1: 'aaa',
            inputClassification1: 'bbb',
            slipNo1:'ccc',
            processingClassification1: 'ddd',
            warehouse1: 'eee',
            location1: 'fff',
            lotNo1: 'ggg',
            warehousing1: 'hhh',
            shipping1: 'iii',
            stock1: 'jjj',
            billingCategory1: 'kkk',
        })
        console.log(data);
    }

    return (
        <div className={style.display}>
            <div className={style.border}>
                <p className={style.text}>商品受支払画面参照</p>
            </div>
            
                <div className={`${style.filed} ${showTable && style.showtable}`} >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={style.container}>
                        <p className={style.containertitle}>商品受払検索</p>
                        <div className={style.flex}>
                            {INPUTS1.map((data) => {
                                return (
                                    data.element == 'select' ? <SelectFiled key={data.name} {...data} register={register} /> : <InputField key={data.name} {...data} register={register} />
                                )
                            })}
                        </div>
                        <div className={style.flex}>
                            {INPUTS2.map((data) => (
                                <InputField key={data.name} {...data} register={register} styles={{width: '260px', marginRight: '48px'}}/>
                            ))}
                        </div>
                        <div className={style.flex}>
                            {INPUTS3.map((data) => {
                                return (
                                    data.element == 'select' ? <SelectFiled key={data.name} {...data} register={register} /> : <InputField key={data.name} {...data} register={register} />
                                )
                            })}
                            <button className={style.button}>検索</button>
                        </div>
                    </div>
                    </form>
                    {showTable && 
                        <table className={style.table}>
                            <thead>
                            <tr>
                                {TABELS.map((data) => (
                                    <th className={style.tableHeader} key={data.name}>{data.label}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody>
                            {TABLE_COUNT.map((count) => (
                                <tr key={count}>
                                {TABELS.map((Data) => (
                                        <TableInput key={Data.name} {...Data} register={register}  name={Data.name + count}/>
                                    ))}
                                </tr>
                                ))}
                            </tbody>
                        </table>}
                </div>
            

        </div>
    )
}

export default ReceivingAndPaymentReference;